import { createSelector } from 'reselect';

export const getComponentState = state => state.staticEditor;

export const getTemplateCode = createSelector(
    getComponentState,
    (state) => state.templateCode
);
export const getQuantity = createSelector(
    getComponentState,
    (state) => state.variables.quantity
);
export const getPrintingOption = createSelector(
    getComponentState,
    (state) => state.variables.printingOption
);
export const getStaticTemplate = createSelector(
    getComponentState,
    (state) => state.staticTemplate
);
export const getFetching = createSelector(
    getComponentState,
    (state) => state.fetching
);
export const getAddingToCart = createSelector(
    getComponentState,
    (state) => state.addingToCart
);
export const getLanguage = createSelector(
    getComponentState,
    (state) => state.variables.language
);
export const getOrientation = createSelector(
    getComponentState,
    (state) => state.variables.orientation
);
export const getMaterialType = createSelector(
    getComponentState,
    (state) => state.variables.materialType
);
export const getSize = createSelector(
    getComponentState,
    (state) => state.variables.size
);
export const getType = createSelector(
    getComponentState,
    (state) => state.variables.type
);
export const getIsFavorite = createSelector(
    getComponentState,
    (state) => state.isFavorite
);
export const getAddingFavorite = createSelector(
    getComponentState,
    (state) => state.addingFavorite
);
export const getCheckingFavorite = createSelector(
    getComponentState,
    (state) => state.checkingFavorite
);
export const getSavingWork = createSelector(
    getComponentState,
    (state) => state.savingWork
);
export const getAction = createSelector(
    getComponentState,
    (state) => state.action
);